var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-box"},[_c('canvas',{ref:"interviewCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/product/interview/banner-bg.vue?vue&type=template&id=130d12c7&scoped=true
// module id = null
// module chunks = 